import Vue from 'vue'
import App from './App.vue'

// 导入BootstrapVue
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
// 导入Bootstrap CSS文件
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

// 导入ElementUI
import 'element-ui/lib/theme-chalk/index.css'
import Element from 'element-ui'
Vue.use(Element)

// 引入路由
import router from './router'

// 引入Code常量
import Code from '@/const/codeConst'
Vue.prototype.$CODE = Code

// 引入axios变量
import http from '@/utils/request'
Vue.prototype.$http = http

// 引入全局配置的管理后台访问地址
Vue.prototype.$ADMIN_URL = 'https://admin.jiuyehui.net'
Vue.prototype.$WWW_URL = 'https://www.jiuyehui.net'

Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
